class ProductRecommendations extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['content']
  }

  constructor () {
    super()

    // Define getters directly in the constructor
    this.baseUrl = this.dataset.baseUrl
    this.limit = this.dataset.limit
    this.productId = this.dataset.productId
    this.sectionId = this.dataset.sectionId

    this.fetchAndRenderRecommendations()
  }

  async fetchAndRenderRecommendations () {
    try {
      const response = await fetch(this.dataset.url)
      const text = await response.text()

      this.processRecommendationsHtml(text)
    } catch (e) {
      console.error(e)
    }
  }

  processRecommendationsHtml (text) {
    // Use DOMParser instead of creating a DOM element.
    // The DOMParser parses HTML without initializing custom elements,
    // which prevents an infinite loop.
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, 'text/html')
    const recommendations = doc.querySelector(this.els.content.selector)

    if (recommendations && recommendations.innerHTML.trim().length) {
      this.innerHTML = recommendations.innerHTML
      this.adjustCarouselBasedOnViewport()
    }
  }

  adjustCarouselBasedOnViewport () {
    const viewportWidth = this.getViewportWidth()

    if (viewportWidth < 768) {
      this.adjustMobileCarousel()
    } else {
      this.adjustDesktopCarousel()
    }
  }

  adjustMobileCarousel () {
    document.querySelectorAll('[data-product-carousel-el]').forEach(slider => {
      slider.classList.remove('keen-slider')
    })
  }

  adjustDesktopCarousel () {
    document.querySelectorAll('[data-image-swiper-el]').forEach(slider => {
      slider.classList.remove('keen-slider')
      slider.classList.remove('keen-slider__slide')
    })
  }

  getViewportWidth () {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    )
  }
}

customElements.define('product-recommendations', ProductRecommendations)
